<template>
  <div class="maintenance-banner">This Application Form will be offline for scheduled Maintenance from {{ startDateTime }} to {{ endDateTime }}. 
    Please be sure to Save / Submit your application prior to this time; you will be able to continue later.</div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { mapGetters } from "vuex";

export default {
  name: "MaintenanceBanner",

  data: () => ({

  }),
  computed: {

    ...mapGetters('maintenance', [
      'startDateTime',
      'endDateTime'
      ])
  },

  methods: {}
};
</script>

<style scoped>
.maintenance-banner {
    color: white;
    background-color: #6f6e6e;
    border-color: #6f6e6e;
    font-weight: 600;
    font-size: 15px;
    padding: 10px 5px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/MaintenanceBanner.vue